import getUserSettingsDetailOptions from "@/features/users/users.queries";
import { Settings } from "@/pages/Settings";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/settings")({
  loader: async ({ context }) => {
    const { queryClient } = context;
    try {
      await queryClient.ensureQueryData(
        getUserSettingsDetailOptions({ staleTime: 5000 }),
      );
    } catch (error) {
      throw redirect({
        to: "/login",
      });
    }
  },
  component: Settings,
});
